import React, { useState, useRef, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutGrid, Search, Bell, HelpCircle, ChevronDown,
  LogOut, Lock, ShieldCheck, Download, Pencil, AppWindow, Rocket
} from 'lucide-react';
import { getClientDownloadApi } from '../api/home';
import EditNameModal from '../components/EditNameModal/EditNameModal';
import '../styles/dashboard.scss';

function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [editNameVisible, setEditNameVisible] = useState(false);
  const dropdownRef = useRef(null);

  // 从 localStorage 读取用户信息
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const displayName = userInfo.channel_name || userInfo.account || '用户';
  const avatarChar = displayName.charAt(0).toUpperCase();
  const [downloadInfo, setDownloadInfo] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    getClientDownloadApi().then(res => { if (res.data) setDownloadInfo(res.data); }).catch(() => {});
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    navigate('/login');
  };

  return (
    <div className="dashboard">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <LayoutGrid size={28} color="#2563eb" />
          <div className="sidebar-logo-text">
            <span className="sidebar-logo-title">Admin Panel</span>
            <span className="sidebar-logo-sub">ENTERPRISE SUITE</span>
          </div>
        </div>
        <nav className="sidebar-nav">
          {/* ====== B权限导航 ====== */}
          <NavLink to="/" className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`} end>
            <LayoutGrid size={18} />
            <span>主页</span>
          </NavLink>
          <NavLink to="/config" className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}>
            <ShieldCheck size={18} />
            <span>租号保护</span>
          </NavLink>
          <NavLink to="/startup" className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}>
            <Rocket size={18} />
            <span>开机启动项</span>
          </NavLink>
          <NavLink to="/help" className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}>
            <HelpCircle size={18} />
            <span>帮助教程</span>
          </NavLink>

          {/* ====== A权限导航 (暂时注释) ====== */}
          {/* <NavLink to="/" className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`} end>
            <LayoutGrid size={18} />
            <span>主页</span>
          </NavLink>
          <NavLink to="/my-apps" className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}>
            <AppWindow size={18} />
            <span>应用管理</span>
          </NavLink>
          <NavLink to="/help" className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}>
            <HelpCircle size={18} />
            <span>帮助教程</span>
          </NavLink> */}
        </nav>
        <div className="sidebar-user">
          <div className="sidebar-user-avatar">{avatarChar}</div>
          <div className="sidebar-user-info">
            <span className="sidebar-user-name">{displayName}</span>
            <span className="sidebar-user-role">高级管理员</span>
          </div>
        </div>
      </aside>
      <div className="main-wrap">
        <header className="topbar">
          <div className="topbar-left">
            {/* {downloadInfo && downloadInfo.url && (
              <button className="topbar-download-btn" disabled={downloading} onClick={() => {
                if (downloading) return;
                setDownloading(true);
                const token = localStorage.getItem('token');
                const isDev = process.env.NODE_ENV === 'development';
                const baseUrl = isDev ? 'http://localhost:8081' : '';
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = `${baseUrl}/umg/home/clientDownloadFile?token=${encodeURIComponent(token)}`;
                document.body.appendChild(iframe);
                setTimeout(() => { document.body.removeChild(iframe); setDownloading(false); }, 5000);
              }}>
                <Download size={16} /> {downloading ? '下载中...' : '下载客户端'}
              </button>
            )} */}
          </div>
          <div className="topbar-actions">
            <button className="topbar-text-btn" onClick={() => navigate('/verify')}>
              <ShieldCheck size={16} />
              <span>实名认证</span>
            </button>
            {/* TODO: 通知和帮助功能后续支持
            <button className="topbar-icon-btn"><Bell size={20} /></button>
            <button className="topbar-icon-btn"><HelpCircle size={20} /></button>
            */}
            <div className="topbar-avatar-wrap" ref={dropdownRef}>
              <div className="topbar-avatar" onClick={() => setDropdownOpen(!dropdownOpen)}>
                <div className="topbar-avatar-circle">{avatarChar}</div>
                <ChevronDown size={14} />
              </div>
              {dropdownOpen && (
                <div className="topbar-dropdown">
                  <div
                    className="topbar-dropdown-item"
                    onClick={() => { setDropdownOpen(false); setEditNameVisible(true); }}
                  >
                    <Pencil size={16} />
                    <span>修改名称</span>
                  </div>
                  <div
                    className="topbar-dropdown-item"
                    onClick={() => { setDropdownOpen(false); navigate('/change-password'); }}
                  >
                    <Lock size={16} />
                    <span>修改密码</span>
                  </div>
                  <div className="topbar-dropdown-divider" />
                  <div className="topbar-dropdown-item danger" onClick={handleLogout}>
                    <LogOut size={16} />
                    <span>退出登录</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </header>
        <main className="main-content">
          {children}
        </main>
      </div>
      <EditNameModal
        visible={editNameVisible}
        currentName={userInfo.channel_name || ''}
        onSuccess={(newName) => {
          setEditNameVisible(false);
          window.location.reload();
        }}
        onCancel={() => setEditNameVisible(false)}
      />
    </div>
  );
}

export default DashboardLayout;
